import { Component } from '@angular/core';
import { LoadingDialogService } from '../loading-dialog.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-loading-dialog',
  templateUrl: './loading-dialog.component.html',
  styleUrls: ['./loading-dialog.component.scss'],
})
export class LoadingDialogComponent {
  isLoading: Subject<boolean> = this.loaderService.isLoading;
  constructor(private loaderService: LoadingDialogService) {}
}
